// extracted by mini-css-extract-plugin
module.exports = {"MainTitle":"main-title_MainTitle__28DNF","logo":"main-title_logo__1PTq-"};